import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useBundle } from '../../contexts/BundleContext';
import { goToCheckout } from '../../utils/checkout';
import { formatPrice } from '../../utils/currency';
import { scrollToSection } from '../../utils/scroll';
export function StickyCTA() {
  const {
    selected
  } = useBundle();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    // Appear once the hero offer has scrolled out of view.
    const onScroll = () => setVisible(window.scrollY > 720);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-319" data-mp="2rvh60r0xp0sj">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gunmetal bg-obsidian/95 backdrop-blur-md md:hidden" style={{
      paddingBottom: 'env(safe-area-inset-bottom)'
    }} data-id="element-320" data-mp="2rs1rpqf33vs6">
          <div className="flex items-center gap-3 px-4 py-3" data-id="element-321" data-mp="1exauc7ddishr">
            <button type="button" onClick={() => scrollToSection('bundles')} className="min-w-0 flex-1 text-left" aria-label="Change bundle" data-id="element-322" data-mp="19wn59r8pglq6">
              <p className="truncate text-[11px] font-semibold uppercase tracking-[0.14em] text-steel" data-id="element-323" data-mp="10xta85b0w3eq">
                {selected.name} · {selected.count} {selected.count === 1 ? 'mask' : 'masks'}
              </p>
              <p className="font-display text-2xl leading-none text-bone" data-id="element-324" data-mp="r7ghhpt213xi">
                {formatPrice(selected.price)}
              </p>
            </button>
            <button type="button" onClick={() => goToCheckout(selected)} className="h-12 shrink-0 whitespace-nowrap bg-bone px-5 text-[11px] font-semibold uppercase tracking-[0.16em] text-obsidian transition-transform duration-150 ease-out active:scale-[0.98]" data-id="element-325" data-mp="h9agrbizi3u8">
              {selected.cta}
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}